var exports = {
  "Er": "ChannelOverviewTab.module__regionOption___VW51WH",
  "pG": "ChannelOverviewTab.module__regionEmoji___VW51WH",
  "Kj": "ChannelOverviewTab.module__regionEmojiText___VW51WH",
  "c5": "ChannelOverviewTab.module__topicInput___VW51WH",
  "Z8": "ChannelOverviewTab.module__emojiButton___VW51WH",
  "IJ": "ChannelOverviewTab.module__emojiButtonInactive___VW51WH",
  "Dg": "ChannelOverviewTab.module__emojiButtonActive___VW51WH",
  "p9": "ChannelOverviewTab.module__sectionWrapper___VW51WH",
  "h3": "ChannelOverviewTab.module__settingsGroup___VW51WH",
  "hB": "ChannelOverviewTab.module__settingsControlRow___VW51WH",
  "S8": "ChannelOverviewTab.module__settingsControlRowStacked___VW51WH",
  "Y4": "ChannelOverviewTab.module__settingsControlText___VW51WH",
  "vK": "ChannelOverviewTab.module__settingsControlTitleRow___VW51WH",
  "H1": "ChannelOverviewTab.module__settingsControlLabel___VW51WH",
  "H7": "ChannelOverviewTab.module__settingsControlDescription___VW51WH",
  "yN": "ChannelOverviewTab.module__settingsSliderControl___VW51WH",
  "S7": "ChannelOverviewTab.module__nameRow___VW51WH",
  "K3": "ChannelOverviewTab.module__nameInput___VW51WH",
};

module.exports = exports;
